
import React, { useEffect, useState } from "react";

import { FaRegEdit } from "react-icons/fa";
import Swal from "sweetalert2";
import { BsTrashFill } from "react-icons/bs";
import DataTable from 'react-data-table-component'
import { IoSearch } from "react-icons/io5";
import { useCreateCategoryMutation, useDeleteCategoryMutation, useGetCategoryQuery, useUpdateCategoryMutation } from "../../store/api/categoryApi";





const initialCategory = {
  Id: 0,
  name: '',
}


export default function Categories() {
  
  const [isUpdate, setIsUpdate] = useState(false);
  const [Category, setCategory] = useState(initialCategory)
  const [CreateCategory] = useCreateCategoryMutation()
  const [updateCategory] = useUpdateCategoryMutation()
  const [deleteCustomer] = useDeleteCategoryMutation()

  const [CategoriesList, setCategoriesList] = useState([]);
  const { data } = useGetCategoryQuery();

  // Update Category state when data changes

  useEffect(() => {
    if (data) {
      setCategoriesList(data);
    }
  }, [data]);




  // create new Category method
  const handlecreateCategory = async (event) => {
    event.preventDefault()

    const Data = {
      name: Category.name,
    }

    await CreateCategory(Data).then((done) => {
        console.log('done', done.data.status)
        if (done.data.status === 200) {
          Swal.fire({
            title: 'Success!',
            text: done.data.message,
            icon: 'success',
            confirmButtonText: 'Done'
          })
        } else {
          Swal.fire({
            title: 'Error!',
            text: done.data.message,
            icon: 'error',
            confirmButtonText: 'close'
          })
        }
      })

      resetFormData()
  }


  // update exist Category
  const handleUpdatesCategory = async (e) => {
    e.preventDefault()

    const CategoryData = {
      Id: Category.Id,
      name: Category.name,
    }


    await updateCategory(CategoryData).then((done) => {
      if (done?.data.status === 200) {
        Swal.fire({
          title: 'Success!',
          text: done.data.message,
          icon: 'success',
          confirmButtonText: 'Done'
        })
      } else {
        Swal.fire({
          title: 'Error!',
          text: done.data.message,
          icon: 'error',
          confirmButtonText: 'Close'
        })
      }
    });

    ResetFormChanges();
  }



  // Delete Category

  const handleDelete = async (value) => {
    const { id } = value
    Swal.fire({
      title: 'Are you sure?',
      text: 'you want to delete this supplier !!!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#022B3A',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        deleteCustomer(id).then((done) => {
          if (done?.data.status === 200) {
            Swal.fire({
              title: 'Success!',
              text: done.data.message,
              icon: 'success',
              confirmButtonText: 'Done'
            })
          } else {
            Swal.fire({
              title: 'Error!',
              text: done.data.message,
              icon: 'error',
              confirmButtonText: 'Close'
            })
          }
        })
      }
    })
  }


  const resetFormData = () => {
    setCategory({
      ...initialCategory,
    });
    
  };


  // reading suppliers list







  // prepare data supplier to be updated
  const handleUpdate = (updateData) => {
      
      if (!isUpdate) {
        setIsUpdate(!isUpdate);
      }
   
      setCategory({
        Id: updateData.id,
        name: updateData.name,
      })
    
  }



   // search Category
   const searchCategory = (searchText) => {
    if (!searchText) {
      return CategoriesList
    }

    const filteredCategoriesList = CategoriesList.filter((category) => {
      const nameMatch = category.name.toLowerCase().includes(searchText.toLowerCase())
      return nameMatch 
    })

    return filteredCategoriesList
  }


  const [page, setPage] = useState(1)
  const [perPage, setPerPage] = useState(3)
  const [formData, setFormData] = useState([])

  // changes pages
  const handlePageChange = (page) => {
    setPage(page)
  }

  // change perpage
  const handlePerPageChange = (perPage) => {
    setPerPage(perPage)
  }

  const ResetFormChanges = () => {
    setIsUpdate(!isUpdate);
    setCategory(initialCategory);
  }

  // search hanlder
  const handleSearch = (e) => {
    setFormData(searchCategory(e.target.value))
  }







  // Category Table columns
  const _columns = [
    { name: 'Id', selector: (row) => row.id, sortable: true, center: true },
   
    {
      name: 'Name',
      selector: (row) => row.name,
      sortable: true,
      center: true
    },
    {
      name: 'Create At',
      selector: (row) => row.created,
      sortable: true,
      center: true
    },
    {
      name: 'Updated At',
      selector: (row) => row.updated,
      sortable: true,
      center: true
    },

    {
      name: 'Actions',
      cell: (row) => (
        <>
          <button
            style={{ background: '#1a2131' }}
            className="btn btn-success me-3 border-0  text-white"
            onClick={() => handleUpdate(row)}
          >
            <FaRegEdit />
          </button>
          <button
            style={{ background: '#A0374F' }}
            className="btn btn-danger me-3 text-white border-0"
            onClick={() => handleDelete(row)}
          >
            <BsTrashFill />
          </button>
        </>
      ),
      center: true
    }
  ]


  const paginatedData = formData.length
  ? formData.slice((page - 1) * perPage, page * perPage)
  : CategoriesList.slice((page - 1) * perPage, page * perPage)



  const canSave = [Category.name].every(Boolean)
  const canUpdate = [Category.name].every(Boolean)






  return (
    <div>
      <div className="block-content-full">
        <div class="block-content">

          <div className="row">
            <div className="col-md-12 col-lg-12 col-sm-12 col-xl-4 col-12">
              <form>
                <div className="row">
                <div className="col-sm-12 hover">
                      <div className="mb-3">
                        <div className="row">
                          <label htmlFor="exampleFormControlInput1" className="form-label text-start">
                          Category Name
                          </label>
                        </div>
                        <input
                        style={{ height: '45px' }}
                        autoComplete='off'
                          type="text"
                          className="form-control"
                          id="exampleFormControlInput1"
                          placeholder="Category Name"
                          value={Category.name}
                          onChange={(e) => setCategory({ ...Category, name: e.target.value })}
                        />
                      </div>
                    </div>
                </div>

                <div class="mt-3 pb-3">
                  <button
                    type="button"
                    class={isUpdate ? "btn btn-success p-2" : "btn btn-primary p-2"}
                    data-dismiss="modal"
                    onClick={isUpdate ? handleUpdatesCategory : handlecreateCategory}
                    disabled={isUpdate ? !canUpdate : !canSave}
                  >
                    {isUpdate ? "Update Changes" : "Save changes"}
                  </button>
                  {
                    isUpdate ?  <button
                      type="button"
                      class={"btn btn-secondary p-2 mx-3"}
                      data-dismiss="modal"
                      onClick={ResetFormChanges}
                    >
                      Reset
                    </button>: (<></>)
                  }
                </div>
              </form>
            </div>


            <div className="col-md-12 col-lg-12 col-sm-12 col-xl-8 col-12 bg-light vh-100">
              <div className="block-content block-content-full">
                <h2 className="content-heading">Category List</h2>
                <div className="d-flex mb-3">
              <div className="input-group">
                <input
                  className="form-control"
                  placeholder="Search..."
                  type="text"
                  style={{ height: '40px' }}
                  //value={searchText}
                  onChange={handleSearch}
                />
                <div className="input-group-append">
                  <span className="input-group-text">
                    <IoSearch />
                  </span>
                </div>
              </div>
          
            </div>
              </div>
              <DataTable
                pointerOnHover
                className="rounded-3"
                columns={_columns}
                data={paginatedData}
                striped
                highlightOnHover
                pagination
                paginationServer
                paginationTotalRows={CategoriesList.length}
                paginationPerPage={perPage}
                paginationRowsPerPageOptions={[1, 3, 5, 50]}
                onChangePage={handlePageChange}
                onChangeRowsPerPage={handlePerPageChange}
              />
            </div>
          </div>


        </div>
      </div>
    </div>
  );
}
